var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1397 7.64575C21.1397 7.4015 20.9983 7.17011 20.7798 7.06727C20.5484 6.95158 20.2913 6.99014 20.0985 7.1444L14.4037 11.6822L21.1397 18.4182V7.64575Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8082 23.9025L8.09669 7.191C7.84602 6.94032 7.43868 6.94032 7.188 7.191C6.93733 7.44167 6.93733 7.84901 7.188 8.09968L11.2321 12.145H10.8553C10.4568 12.145 10.1097 12.325 9.87832 12.6078C9.68549 12.8263 9.5698 13.122 9.5698 13.4305V18.5725C9.5698 19.2795 10.1483 19.858 10.8553 19.858H13.8377L20.098 24.8586C20.2137 24.9486 20.3551 25 20.4965 25C20.5865 25 20.6894 24.9743 20.7794 24.9357C20.9979 24.8329 21.1393 24.6015 21.1393 24.3572V22.0522L23.8979 24.8108C24.024 24.9369 24.1883 24.9996 24.353 24.9996C24.5178 24.9996 24.6821 24.9365 24.8082 24.812C25.0589 24.5601 25.0589 24.154 24.8082 23.9017V23.9025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMute);
export default __webpack_public_path__ + "static/media/ic_mute.4d8b024e542a44686e8a2c063fafc1e4.svg";
export { ForwardRef as ReactComponent };